import LottieRaw from 'lottie-react';
import data from './smiley.incorrect.json.js';
import { jsx } from 'react/jsx-runtime';

const Lottie = LottieRaw.default ?? LottieRaw;
function IncorrectSmileyIcon(props) {
  return /*#__PURE__*/jsx(Lottie, {
    loop: false,
    ...props,
    animationData: data
  });
}
IncorrectSmileyIcon.blink = lottie => {
  if (!lottie || !lottie.animationItem) {
    return;
  }
  if (lottie.animationItem.currentFrame >= lottie.animationItem.totalFrames - 1) {
    lottie.goToAndPlay(90, true);
  }
};

export { IncorrectSmileyIcon };
//# sourceMappingURL=smiley.incorrect.js.map
